import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { IProductGroup } from '../../../../types/product'
import { getUrlWithVersion } from '../../../../api/api'

export const changeGroupsPositions = createAsyncThunk<
    void,
    { reorderedGroups: IProductGroup[]; positions: string[] },
    ThunkConfig<string>
>('productsSlice/changeGroupsPositions', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { positions } = args

    try {
        await api.put(getUrlWithVersion(`/groups/positions`), { positions })
        throwSuccessMessage('Success!')
    } catch (e) {
        alertErrorMessage(e)
        dispatch(fetchProductsGroups())
        return rejectWithValue('Failed to reorder groups')
    }
})
